const transitionDurations = {
  'transition-duration-short': '0.1s',
  'transition-duration-default': '0.2s',
  'transition-duration-long': '0.3s',
};

module.exports = transitionDurations;
